import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFindAllCompaniesQuery } from "../../../features/companyApi";
import { useFindAllPeopleQuery } from "../../../features/peopleApi";
import { ContactType, FindAllContactsFilters, FindContactsDatabaseResponse } from "../../lib/filters/dto";
import { initialStateContactsFilters } from "../../lib/filters/filtersSlice";
import { Preferences } from "../../lib/preferences";
import { PreferencesSection } from "../../lib/preferences/dto";
import { BuildingIcon } from "../../ui/icons/building";
import { DownloadIcon } from "../../ui/icons/download";
import { UsersIcon } from "../../ui/icons/users";
import { Layout } from "../../ui/layout";
import Button from "../../ui/molecules/button";
import { Spinner } from "../../ui/molecules/spinner";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { TabMenu } from "../../ui/organisms/tabs/tabMenu";
import { TabPages } from "../../ui/organisms/tabs/tabPages";
import { useDownloadCsv } from "../database/commons/useDownloadCsv";
import { Companies } from "../database/companies/list";
import { People } from "../database/people/list";
import { keycloak } from "../../lib/keycloak";

export function BlackList() {
    const [peopleFilters, setPeopleFilters] = useState<FindAllContactsFilters>(initialStateContactsFilters['black-list'][ContactType.PERSON]);
    const { data: peopleData, isLoading: isLoadingPeople } = useFindAllPeopleQuery(peopleFilters);
    const [peopleSelectedIds, setPeopleSelectedIds] = useState<string[]>([]);
    const downloadPeopleCsv = useDownloadCsv(peopleSelectedIds, setPeopleSelectedIds, ContactType.PERSON);

    const [companiesFilters, setCompaniesFilters] = useState<FindAllContactsFilters>(initialStateContactsFilters['black-list'][ContactType.COMPANY]);
    const { data: companiesData, isLoading: isLoadingCompanies } = useFindAllCompaniesQuery(companiesFilters);
    const [companiesSelectedIds, setCompaniesSelectedIds] = useState<string[]>([]);
    const downloadCompaniesCsv = useDownloadCsv(companiesSelectedIds, setCompaniesSelectedIds, ContactType.COMPANY);

    const tabValue = useParams().tab
    const [direction, setDirection] = useState<'left' | 'right'>("left")
    const navigate = useNavigate()

    if (isLoadingPeople || isLoadingCompanies) {
        return <div className="flex items-center justify-center h-screen w-full"><Spinner /></div>
    }

    return (
        <Layout
            headerLabel={"Lista nera"}
            breadcrumbItems={['Lista Nera']}
            menuItem={MenuItems.BLACK_LIST}
            headerChildren={
                <div className="flex justify-between items-center">
                    <TabMenu
                        direction={direction}
                        setDirection={(value) => setDirection(value)}
                        setValue={(e) => {
                            if (e === 0) {
                                navigate(window.location.pathname.replace(/\/specifics|\/companies/, "/people"));
                            }
                            if (e === 1) {
                                navigate(window.location.pathname.replace(/\/specifics|\/people/, "/companies"));
                            }
                        }}
                        value={tabValue === 'companies' ? 1 : 0}
                        items={[
                            {
                                icon: <UsersIcon color={""} size={0} />,
                                label: "Persone",
                            },
                            {
                                icon: <BuildingIcon color={""} size={0} />,
                                label: "Aziende",
                            },
                        ]}
                    />
                    <div className="flex gap-2">
                        {peopleSelectedIds.length > 0 && tabValue === 'people' && !keycloak.hasRealmRole('commercial') && (
                            downloadPeopleCsv.loading ?
                                <Spinner /> :
                                <Button
                                    size={"sm"}
                                    iconPosition={"left"}
                                    label="Esporta"
                                    variant={"outline"}
                                    color={"blue"}
                                    icon={<DownloadIcon color={""} size={0} />}
                                    onClick={() => downloadPeopleCsv.handleDownloadConfirm()}

                                />
                        )}
                        {companiesSelectedIds.length > 0 && tabValue === 'companies' && !keycloak.hasRealmRole('commercial') && (
                            downloadCompaniesCsv.loading ?
                                <Spinner /> :
                                <Button
                                    size={"sm"}
                                    iconPosition={"left"}
                                    label="Esporta"
                                    variant={"outline"}
                                    color={"blue"}
                                    icon={<DownloadIcon color={""} size={0} />}
                                    onClick={() => downloadCompaniesCsv.handleDownloadConfirm()}

                                />
                        )}
                    </div>
                </ div>
            }
        >
            <div className="flex max-w-full w-full max-h-full h-full overflow-hidden p-4">
                <div className="flex max-w-full w-full h-full rounded-xl flex-col relative rounded-t-xl bg-white shadow-sm ">
                    <div className="max-h-full max-w-full h-full rounded-xl">
                        <TabPages
                            direction={direction}
                            setDirection={(value) => setDirection(value)}
                            pages={[
                                <People
                                    section="black-list"
                                    selectedIds={peopleSelectedIds}
                                    setSelectedIds={(ids) => {
                                        setPeopleSelectedIds(ids)
                                    }}
                                    contacts={peopleData?.people as unknown as FindContactsDatabaseResponse<ContactType.PERSON>}
                                    onPageChange={(page) => setPeopleFilters((f) => ({ ...f, page }))}
                                    onItemsPerPageChange={(itemsPerPage) => setPeopleFilters((f) => ({ ...f, itemsPerPage, page: 0 }))}
                                    filters={peopleFilters}
                                    onChangeFilters={f => setPeopleFilters(prevFilters => ({ ...prevFilters, ...f, page: 0 }))}
                                    toActivate={peopleData?.toActivate ?? 0}
                                    key={0}
                                />,
                                <Companies
                                    section="black-list"
                                    selectedIds={companiesSelectedIds}
                                    setSelectedIds={(ids) => {
                                        setCompaniesSelectedIds(ids)
                                    }}
                                    contacts={companiesData?.companies as unknown as FindContactsDatabaseResponse<ContactType.COMPANY>}
                                    onPageChange={(page) => setCompaniesFilters((f) => ({ ...f, page }))}
                                    onItemsPerPageChange={(itemsPerPage) => setCompaniesFilters((f) => ({ ...f, itemsPerPage, page: 0 }))}
                                    filters={companiesFilters}
                                    onChangeFilters={f => setCompaniesFilters(prevFilters => ({ ...prevFilters, ...f, page: 0 }))}
                                    toActivate={companiesData?.toActivate ?? 0}
                                    key={1}
                                />
                            ]}
                            value={tabValue === 'companies' ? 1 : 0}
                            setValue={(e) => {
                                if (e === 0) {
                                    navigate(window.location.pathname.replace(/\/specifics|\/companies/, "/people"));
                                }
                                if (e === 1) {
                                    navigate(window.location.pathname.replace(/\/specifics|\/people/, "/companies"));
                                }
                            }}
                        />
                    </div>
                </div>
                <Preferences section={tabValue === 'people' ? PreferencesSection.personPreferences : PreferencesSection.companyPreferences} key={tabValue === 'people' ? PreferencesSection.personPreferences : PreferencesSection.companyPreferences} />
            </div>
        </Layout>
    )
}